import { useMutation } from "@apollo/client/react";
import { SEND_BUDGET_SIGNAL } from "utils/queries";
import { useAppDispatch } from "store";
import { useTranslation } from "react-i18next";
import { logger } from "utils/logger";
import { showAction, NEW_LEARNING_ACTION_TYPE, NEW_LEARNING_ALERT_TYPE } from "./newLearningHelper";
import { SubmitBudgetCheckModel } from "utils/graphql/Global";

export const useSubmitBudgetSignal = () => {
  const [sendBudgetSignal] = useMutation(SEND_BUDGET_SIGNAL);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const submit = async (submitBudgetCheckModel: SubmitBudgetCheckModel, onSuccess?: () => void) => {
    showAction(dispatch, NEW_LEARNING_ACTION_TYPE.LOADER_SHOW_AND_HIDE, {
      show: true,
      message: t("budget_check_title"),
    });

    try {
      await sendBudgetSignal({ variables: { payload: submitBudgetCheckModel } });
      onSuccess?.();
    } catch (error) {
      logger.error("Failed to send budget signal", {
        error: error instanceof Error ? error.message : String(error),
      });
      showAction(dispatch, NEW_LEARNING_ACTION_TYPE.ALERT_SHOW, {
        type: NEW_LEARNING_ALERT_TYPE.ERROR,
        title: t("budget_check_title"),
        message: t("budget_save_error"),
      });
    } finally {
      showAction(dispatch, NEW_LEARNING_ACTION_TYPE.LOADER_SHOW_AND_HIDE, { show: false });
    }
  };

  return submit;
};

export default useSubmitBudgetSignal;
